import React from 'react';
import '../../styles/home.css';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';

function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="eduss-home-page">
      <header className="eduss-home-header">
        <div className="eduss-home-logo" onClick={() => navigate('/')}>EDUSS</div>
        <nav className="eduss-home-nav">
          <Link to="/" className="eduss-home-nav-link">Home</Link>
          <Link to="/about" className="eduss-home-nav-link">About</Link>
          <Link to="/contact" className="eduss-home-nav-link">Contact</Link>
          <button className="eduss-home-login-btn" onClick={() => navigate('/login')}><FaUser /> Login</button>
        </nav>
      </header>
      <main className="eduss-home-hero">
        <h1 className="eduss-home-hero-title">Welcome to EDUSS</h1>
        <p className="eduss-home-hero-desc">A comprehensive digital platform for education supply and services management.</p>
        <button className="eduss-home-cta" onClick={() => navigate('/login')}>Get Started</button>
      </main>
      <footer className="eduss-home-footer">&copy; {new Date().getFullYear()} EDUSS. All rights reserved.</footer>
    </div>
  );
}

export default HomePage;